if (typeof window !== 'undefined' && typeof HTMLElement !== 'undefined') {
  // Generic components
  import('./icon');
  import('./dropdown');
  import('./tooltip');
  import('./modal');
  // Comments
  import('./comments');
  import('./comments/components/topbar');
  import('./comments/components/content');
  import('./comments/components/comment-item');
  import('./comments/components/comment-input');
  import('./comments/components/annotation-pin');
  import('./comments/components/annotation-item');
  import('./comments/components/delete-comment-modal');
  import('./comments/components/annotation-resolved');
  import('./comments/components/annotation-filter');
  import('./comments/components/float-button');
  import('./comments/components/mention-list');
  // Who is Online
  import('./who-is-online');
  import('./hello-world');
}
